export default "__VITE_ASSET__CBctraFQ__"